const configuredServer = String(process.env.REACT_APP_ATTUNEWISE_SERVER || '')
  .trim()
  .replace(/\/+$/, '')

const developmentServer = process.env.NODE_ENV === 'development'
  ? 'http://localhost:8080'
  : ''
const attunewiseServer = configuredServer || developmentServer

if (!attunewiseServer) {
  throw new Error('REACT_APP_ATTUNEWISE_SERVER is required outside local development')
}

export { attunewiseServer }
